import 'bulma/css/bulma.css';
import * as Sentry from '@sentry/vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSort,
  faSortUp,
  faSortDown,
  faCheck,
  faTimes,
  faBell,
  faChevronLeft,
  faChevronDown,
  faAngleDown,
  faGraduationCap,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { createApp } from 'vue';
import App from './App.vue';
import router from './routes';
import { installUnhandledRejectionHandler } from './unhandledRejection';

library.add(faSort);
library.add(faSortUp);
library.add(faSortDown);
library.add(faCheck);
library.add(faTimes);
library.add(faBell);
library.add(faChevronLeft);
library.add(faChevronDown);
library.add(faAngleDown);
library.add(faGraduationCap);

const app = createApp(App);

if (process.env.VUE_APP_SENTRY_DSN) {
  // autoInject: false — the "Report a Bug" widget is shown only to logged-in users,
  // toggled below, rather than to anyone who can merely reach the login screen.
  const feedback = Sentry.feedbackIntegration({ autoInject: false });

  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || 'production',
    integrations: [
      feedback,
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration({ router }),
    ],
    // Replay-on-error only, no random session sampling — keeps usage within the
    // free-tier 50 replays/month quota.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Tracing is free (5M spans/mo, same quota across all Sentry plan tiers). Traffic
    // for this app is well within that, so trace every request rather than sampling.
    tracesSampleRate: 1.0,
  });

  let feedbackWidget = null;
  router.afterEach(() => {
    const loggedIn = !!localStorage.getItem('token');
    if (loggedIn && !feedbackWidget) {
      feedbackWidget = feedback.createWidget();
    } else if (!loggedIn && feedbackWidget) {
      feedbackWidget.removeFromDom();
      feedbackWidget = null;
    }
  });
}

installUnhandledRejectionHandler();

app.use(router);
app.component('FontAwesomeIcon', FontAwesomeIcon);
app.mount('#app');
